import Form from './form';
import Roles from '../collection/roles';
import TaskStates from '../collection/task.states';

export default Form.extend( {
    events: {
        'click .-add-edit-cancel'() {
            this.trigger( ':possible-value:add-edit-cancel' );
        },

        'click .-add-edit-save'() {
            this.trigger( `:possible-value:${this.options.saveEvent}`,
                this.model.toJSON() );
        },
    },

    onBind(model) {
        console.log( 'on bind', model );
        this.listenTo( model, 'change',
            () => console.log( 'model changed! =>', model.toJSON() ) );
    },

    ds: {
        states: TaskStates,
    },

    serialize() {
        const { roles, } = this.options;
        return {
            roles: roles.toJSON(),
            title: this.options.title,
            type: this.options.type,
        };
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/config.value.item.mode.edit.js